import { createBrowserRouter} from "react-router-dom";
import AuthRoutes from "./routes/auth";
import AuthenticatedRoutes from "./routes/dashroutes";
import AdminRoutes from "./routes/adminroutes";


const App = createBrowserRouter([
  ...AuthRoutes,
  ...AuthenticatedRoutes,
  ...AdminRoutes,
])




export default App;
